import React from 'react'
import TopHeading from './TopHeading'
import Accordion from './common/Accordian';

const all_questions = [
    {
        id: 1,
        question: 'Can you integrate your systems with our existing software?',
        answer: 'Yes. We offer API integrations with leading CRMs, finance platforms, HR systems, and construction tools.'
    },
    {
        id: 2,
        question: 'Can we build an app tailored to our workforce?',
        answer: 'Absolutely. We design apps around your workflow—whether for contractors, project managers, or health & safety officers.'
    },
    {
        id: 3,
        question: 'What is your typical turnaround time for a new website?',
        answer: '3–5 weeks depending on size and features. Custom systems take 6–12 weeks based on complexity.'
    },
    {
        id: 4,
        question: 'How can your solutions support health and safety compliance?',
        answer: 'We provide digital forms, real-time incident logging, inspection checklists, and automatic H&S reporting.'
    },
    {
        id: 5,
        question: 'Is post-launch support included?',
        answer: 'Yes. We offer dedicated support, updates, bug fixes, and feature enhancements.'
    },
    {
        id: 6,
        question: 'Can we manage multiple construction sites from one system?',
        answer: 'Definitely. Our platforms offer site-specific controls with central oversight.'
    },
    {
        id: 7,
        question: 'Can you help us get more leads online?',
        answer: 'Yes. We offer targeted marketing services to attract clients in your region or specialty.'
    },
    {
        id: 8,
        question: 'Can we customise the quoting workflow?',
        answer: 'Yes. From tiered pricing to client-side approval, we tailor it to how you work.'
    }
]

const Faqs = () => {

    return (
        <>
            <section className='py-5' id='faqs' style={{ backgroundColor: "rgb(241, 242, 243)" }}>
                <div className='auto-container py-md-5'>
                    <div className='row'>
                        <div>
                            <TopHeading head={"Faq's"} title={'Frequently Asked Questions'} className='text-center' />
                        </div>

                        <div className='mt-5'>
                            <div className='row'>
                                <div className="col-md-6">
                                    <Accordion questions={all_questions.slice(0, 4)} />
                                </div>
                                <div className="col-md-6">
                                    <Accordion questions={all_questions.slice(4, 8)} />
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </section>
        </>
    )
}

export default Faqs